angular.module('rightPaneModule')
.controller('GuardianUsageController', ['$scope', 'studentApi', 'timeframe', 'cancelableResourceManager', '$state', function($scope, $studentApi, $timeframe, $cancelableResourceManager, $state) {

  $scope.years = { list: null, selected: {} };
  $scope.timeframes = {
    list: [
      { id: '7d', name: 'Last 7 Days', by: 'day', active: true },
      { id: '30d', name: 'Last 30 Days', by: 'week', active: false }
    ],
    selected: {}
  };

  var updateUsageData = function() {
    $scope.usageData = undefined;
    var promise = $studentApi.getStudentUsageForGuardian(function(usageData) {
      $scope.usageData = usageData;
      $cancelableResourceManager.remove(pid);
    });
    var pid = $cancelableResourceManager.add(promise);
  };

  var initializeData = function(e, item) {
    $scope.item = item;

    if(!$state.params.timeframe) {
      $timeframe.updateStateParams($scope.timeframes.selected.id, $scope.timeframes.selected.by);
    }
  };

  $scope.$on('updateStudentDataForGuardian', function(e) {
    $scope.busy = true;
    updateUsageData();
  });

  $scope.$on('updateYears', function(e, years) {
    $scope.years.list = angular.copy(years);
  });

  $scope.$on('itemReady', initializeData);
  $scope.$on('timeframeSelected', updateUsageData);

}]);
